import React from 'react';

export const PreviewIcon = (props) => {
    return (
        <svg width="16" height="12" viewBox="0 0 16 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M0.378473 5.1868C1.63581 2.80527 4.40127 -8.80744e-05 8.00022 2.07387e-09C11.6247 8.87038e-05 14.4282 2.87374 15.6665 5.27322C15.9021 5.72958 15.9021 6.27042 15.6665 6.72678C14.4282 9.12626 11.6247 11.9999 8.00022 11.9999C4.45568 11.9999 1.71962 8.89014 0.436531 6.78357C0.139358 6.29567 0.111755 5.69199 0.378473 5.1868ZM8.00022 9C9.65707 9 11.0002 7.65685 11.0002 6C11.0002 4.34315 9.65707 3 8.00022 3C6.34336 3 5.00022 4.34315 5.00022 6C5.00022 7.65685 6.34336 9 8.00022 9Z" />
        </svg>
    )
}
